import { ElementTypes } from '@bynder-studio/render-core';

export enum DesignTab {
    SCENE = 'SCENE',
    VARIATIONS = 'VARIATIONS',
    TRANSCRIPT = 'TRANSCRIPT',
}

export type ShotElementType = Lowercase<ElementTypes>;
